export default "/images/cfda0f44f34b032bd596a52003073aa0.avif";